import { render } from "./BannersPage.vue?vue&type=template&id=638625ec"
import script from "./BannersPage.vue?vue&type=script&lang=js"
export * from "./BannersPage.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__